import styled, { css } from 'styled-components';
import { mobile_xl } from '../../global/mediaQueryMixin';

const ActionDiv = styled.div`
  display: flex;
  .three-dot-icon {
    display: flex;
    gap: var(--space-12);
    order: 3;
  }
  .active {
    border-radius: var(--border-radius-8);
    background: var(--neutral-secondary);
  }
  ${mobile_xl(css`
    /* this is given to manage spacing of 30px */
    &.figma-right-div {
      padding-left: var(--space-6);
      margin-left: var(--space-24);
    }
  `)}
`;

export { ActionDiv };
